import * as React from "react";
import { useCopilotSourceOffer } from "../../src/taskpane/components/copilot/useCopilotSourceOffer";
import type { ICopilotFileRef } from "../../src/taskpane/services/copilot/copilotScope";
import { ILibraryPlace, libraryRowFileRef } from "../../src/taskpane/services/copilot/copilotFileRefs";

const NO_ROWS: any[] = [];

/**
 * A grid offers its selection to the Copilot pane (spec 2026-10-22 §2.5): `source` names the grid,
 * `rows` are its selected raw rows, `place` where they are (null: nothing to offer, a SharePoint list
 * say), `placeLabel` the "selected in ⟨library⟩" text and `enabled` whether Copilot is on here
 * (useContentManagerCopilotEnabled). Only while the pane is open and Copilot is on are refs built and
 * the offer written (the performance rule, §2.11): with the pane closed a selection change touches no
 * Redux at all, nor with a pane remembered open for a user who has no Copilot (final review
 * 2026-10-22). The offer follows the selection live and never adds by itself. The grid withdraws only
 * the offer it made (clearCopilotOffer(source)), when nothing readable is selected, the pane closes,
 * Copilot goes off or the grid goes. The work is useCopilotSourceOffer's.
 */
export const useCopilotGridOffer = (source: string, rows: any[], place: ILibraryPlace | null, placeLabel: string, enabled: boolean): void => {
  // Memoised on the place, so the offer is made again only when the grid's place changes.
  const toRef = React.useCallback((row: any): ICopilotFileRef | null => libraryRowFileRef(row, place), [place]);
  useCopilotSourceOffer(source, place ? rows : NO_ROWS, toRef, { place: placeLabel, kind: "selected" }, enabled);
};
